import { InstagramLogo, TiktokLogo } from '@phosphor-icons/react';
import ExternalLink from './ExternalLink';
import { externalLinks } from '../config/links';

export default function SocialLinks({ className = '' }) {
  return (
    <div className={`social-links ${className}`.trim()}>
      <ExternalLink
        className="icon-button"
        href={externalLinks.instagram}
        aria-label="Follow ShareShutter on Instagram"
      >
        <InstagramLogo size={20} weight="fill" aria-hidden="true" />
      </ExternalLink>

      <ExternalLink
        className="icon-button"
        href={externalLinks.tiktok}
        aria-label="Follow ShareShutter on TikTok"
      >
        <TiktokLogo size={20} weight="fill" aria-hidden="true" />
      </ExternalLink>
    </div>
  );
}
